import { render, staticRenderFns } from "./StoreFileBlobsView.vue?vue&type=template&id=348063b9&"
import script from "./StoreFileBlobsView.vue?vue&type=script&setup=true&lang=ts&"
export * from "./StoreFileBlobsView.vue?vue&type=script&setup=true&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports